export const STORAGE_TOKEN_KEY = 'token';
export const STORAGE_SW_TOKEN_KEY = 'sw_token';
export const STORAGE_PLATFORM_KEY = 'platform';
export const STORAGE_CHANNEL_KEY = 'channel';
export const STORAGE_SCHANNEL_KEY = 'schannel';
export const STORAGE_OPEN_ID_KEY = 'open_id';
export const USER_INFO_KEY = 'user_info';
